<script setup>
defineProps({
  label: {
    type: String,
    default: '',
  },
  hasMargin: {
    type: Boolean,
    default: true,
  },
})
</script>

<template>
  <div
    :class="{
      [$style.divider]: true,
      [$style.hasMargin]: hasMargin,
    }"
  >
    <div :class="$style.line" />
    <template v-if="label || $slots.default">
      <small><slot>{{ label }}</slot></small>
      <div :class="$style.line" />
    </template>
  </div>
</template>

<style module>
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 100%; /* In case the divider is used inside a flex container */
  color: var(--color-text-muted);
  text-transform: uppercase;
  &.hasMargin {
    margin: 1rem 0;
  }
}
.line {
  flex: 1;
  height: 1px;
  background-color: var(--color-borders);
}
</style>
